import React, { FC } from "react";

import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import { Link, Stack, Typography } from "@mui/material";

const ManageCookies: FC = () => {
  return (
    <Stack
      sx={{
        border: `solid 1px ${Colors.BorderDefault}`,
        borderRadius: "8px",
        width: "100%",
        maxWidth: "750px",
        marginX: "auto",
        padding: "20px",
        marginY: "24px",
        gap: "10px",
      }}
    >
      <Typography variant="h5">Manage your cookie preferences</Typography>

      <Typography variant="body1">
        To manage your cookie settings{" "}
        <Link href="javascript: Cookiebot.renew()">click here</Link>. To revoke
        your consent{" "}
        <Link href="javascript: Cookiebot.withdraw()">click here</Link>. If the
        links do not work, your browser may be blocking 3rd party scripts. Check
        your browser settings, refresh the page, and try again. If you have
        comments, questions or concerns{" "}
        <Link href="/contact-us">contact us</Link>.
      </Typography>
    </Stack>
  );
};

export default ManageCookies;
